




























































































































import { 
  Component, Vue, Prop, Watch 
} from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Option } from '@/components/base/BaseSelect.vue';
import { sort } from '@/utils/sort';
import { GroupsState } from '@/store/modules/groups/types';
import { CircuitsState } from '@/store/modules/circuits/types';
import { DevicesState } from '@/store/modules/devices/types';
import { ReportsAction, ReportsActionType } from '@/store/modules/reports/types';
import { isGateway } from '@/utils/type_check';
import { CreateReportRequest } from '@/api/bff/reports';
import { AppGetter } from '@/store/modules/app/types';
import { getLoggedUserId } from '@/utils/helpers';

const reports = namespace('reports');

@Component
export default class ScheduleTab extends Vue {
  filterType: string = 'none';

  filterValue: string = '';

  scheduleOption: 'weekly' | 'daily' | 'monthly' | undefined = 'weekly';

  startTimestamp: string = new Date(Date.now() - 86400000).toISOString().substring(0, 10);

  endTimestamp: string = new Date().toISOString().substring(0, 10);

  reportTitle: string = this.defaultReportTitle;

  snackbarVisible: boolean = false;

  isSuccess: boolean = true;

  @Prop() circuits!: CircuitsState['circuits'];

  @Prop() groups!: GroupsState['groups'];

  @Prop() devices!: DevicesState['devices'];

  @reports.Action(ReportsAction.CreateReportConfig)
  createReportConfig!: ReportsActionType['CREATE_REPORT_CONFIG'];

  get filterTypeOptions(): Array<Option> {
    return [{ text: this.$t('reports.filterAll') as string, value: 'none' },
      { text: this.$t('reports.filterCircuit') as string, value: 'circuit' },
      { text: this.$t('reports.filterGroup') as string, value: 'group' },
      { text: this.$t('reports.filterGateway') as string, value: 'gateway' }];
  }

  get scheduleOptions(): Array<Option> {
    return [{ text: this.$t('reports.daily') as string, value: 'daily' },
      { text: this.$t('reports.weekly') as string, value: 'weekly' },
      { text: this.$t('reports.monthly') as string, value: 'monthly' }];
  }

  get filterValues(): Option[] {
    switch (this.filterType) {
      case 'circuit':
        return this.circuits.sort((a, b) => sort(a.name, b.name)).map((circuit) => ({ text: circuit.name, value: circuit.uuid || '' }));
      case 'group':
        return this.groups.sort((a, b) => sort(a.name, b.name)).map((group) => ({ text: group.name, value: group.uuid || '' }));
      case 'gateway':
        return this.devices.filter(isGateway).sort((a, b) => sort(a.object_display_name ?? a.object_id, b.object_display_name ?? b.object_id)).map((gateway) => ({ text: gateway.object_display_name ?? gateway.object_id, value: gateway.object_id }));
      case 'device':
        return this.devices.filter((device) => !isGateway(device)).sort((a, b) => sort(a.object_display_name ?? a.object_id, b.object_display_name ?? b.object_id)).map((device) => ({ text: device.object_display_name ?? device.object_id, value: device.object_id }));
      default:
        return [];
    }
  }

  get dropdownPlaceholder() {
    switch (this.filterType) {
      case 'circuit':
        return this.$t('reports.searchCircuit') as string;
      case 'group':
        return this.$t('reports.searchGroup') as string;
      case 'gateway':
        return this.$t('reports.searchGateway') as string;
      default:
        return this.$t('reports.noFiltering') as string;
    }
  }

  get defaultReportTitle() {
    return `Raport ${new Date().toLocaleDateString('pl-PL')}`;
  }

  get snackbarMessage() {
    return this.isSuccess ? this.$t('reports.configAdded') as string : this.$t('reports.errorAddingConfig') as string;
  }

  async scheduleReport() {
    try {
      if (this.reportTitle === null || this.reportTitle === '') {
        this.reportTitle = this.defaultReportTitle;
      }
      const token = this.$store.getters[`app/${AppGetter.GetToken}`];
      const userId = getLoggedUserId(token);
      const config: CreateReportRequest = {
        object_display_name: this.reportTitle,
        filter_type: this.mapFilterType(this.filterType),
        filter_value: this.filterValue,
        start_date: new Date(this.startTimestamp),
        end_date: new Date(this.endTimestamp),
        type: 'scheduled',
        repeating_interval: this.scheduleOption,
        created_by: userId?.toString() ?? 'none'
      };

      await this.createReportConfig(config);
      this.isSuccess = true;
      this.snackbarVisible = true;
    } catch (error) {
      console.error('Failed to schedule report:', error);
      this.isSuccess = false;
      this.snackbarVisible = true;
    }
  }

  mapFilterType(filterType: string): 'none' | 'object_id' | 'circuit_uuid' | 'group_uuid' {
    switch (filterType) {
      case 'circuit':
        return 'circuit_uuid';
      case 'group':
        return 'group_uuid';
      case 'gateway':
      case 'device':
        return 'object_id';
      case 'none':
      default:
        return 'none';
    }
  }

  @Watch('filterType')
  onFilterTypeChange(newValue: string) {
    if (newValue === 'none') {
      this.filterValue = 'none';
    } else {
      this.filterValue = '';
    }
  }
}
